import { WrappedFieldProps } from 'redux-form';
import Markdown from 'shared/components/Markdown';
import styled from 'styled-components';

import FormError from 'inquiry/components/FormError';
import PhoneInput, { PhoneInputProps } from 'inquiry/components/PhoneInput';
import { containerSSTStyles, labelSSTStyles } from 'inquiry/mixins/form';
import { InputTextBaseStyles } from 'lib/interfaces/ui-components';

const Container = styled('div')<{ styles?: InputTextBaseStyles }>`
  ${({ styles }) => containerSSTStyles(styles)}
  ${({ styles }) => labelSSTStyles(styles)}
`;

export interface PhoneInputFieldProps {
  id: string;
  autoFocus?: boolean;
  label?: string;
  className?: string;
  placeholder?: string;
  'data-test'?: string;
  serverError?: string;
  styles?: InputTextBaseStyles;
}

const PhoneInputField = (props: WrappedFieldProps & PhoneInputProps & PhoneInputFieldProps) => {
  const {
    id,
    className,
    input,
    meta: { error, submitFailed, warning },
    autoFocus,
    label,
    placeholder,
    'data-test': dataTest = 'form',
    defaultCountry,
    serverError,
    styles,
    ...passthroughProps
  } = props;

  const errorToDisplay = (submitFailed && (error || warning)) || serverError;
  const hasError = !!errorToDisplay;

  return (
    <Container className={className} styles={styles}>
      {label && (
        <Markdown<'label'> wrapper='label' wrapperProps={{ htmlFor: id }}>
          {label}
        </Markdown>
      )}
      <PhoneInput
        {...input}
        {...passthroughProps}
        autoFocus={autoFocus}
        hasError={hasError}
        aria-invalid={hasError}
        aria-errormessage={`${id}--error`}
        aria-describedby={`${id}--error`}
        id={id}
        placeholder={placeholder}
        defaultCountry={defaultCountry}
        data-test={dataTest}
        styles={styles}
      />
      <FormError
        id={`${id}--error`}
        data-test={`${dataTest}-error`}
        hasError={hasError}
        errorMessage={errorToDisplay}
        styles={styles}
      />
    </Container>
  );
};

export default PhoneInputField;
